import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { AttendContactAbsenceJson } from '@/types/domain/attendContact/entities/attendContactAbsenceEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import AbsenceInfo from '@/domain/attendContact/component/AbsenceInfo';

/**
 * プロパティ
 */
export type DeleteAbsenceInput = {
  /** データ */
  data: AttendContactAbsenceJson | undefined,
  /** 閉じる */
  close: (v: AttendContactAbsenceJson | undefined) => void,
}

const DeleteAbsence: React.FC<DeleteAbsenceInput> = ({ data, close }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => close(undefined)}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="欠席連絡" />
    <DialogContent>
      {data && <AbsenceInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => close(data)} color="primary">
        削除する
      </Button>
      <Button variant="contained" onClick={() => close(undefined)} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteAbsence;
